/* 
fiky-web
*/

import React, { useState } from "react";
import { useSelector, useDispatch} from "react-redux";
import { Container, Row, Col, CardTitle } from "reactstrap";
import CommonSection from "../components/UI/common-section/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import { cartActions } from "../store/shopping-cart/cartSlice";
import "../styles/checkout.css";

const Checkout = () => {
  const [enterName, setEnterName] = useState("");
  const [enterNumber, setEnterNumber] = useState("");
  const [enterMakan, setEnterMakan] = useState("");

  const shippingInfo = [];
  const cartTotalAmount = useSelector((state) => state.cart.totalAmount);
  const cartItems = useSelector((state) => state.cart.cartItems);


  const shippingCost = 0;
  const totalAmount = cartTotalAmount + Number(shippingCost);

  const submitHandler = (e) => {
    e.preventDefault();
    const userShippingAddress = {
      name: enterName,
      phone: enterNumber,
      Makan: enterMakan,
    };
    shippingInfo.push(userShippingAddress);
    console.log(shippingInfo);
    //window.open("https://api.whatsapp.com/send/?phone=6285811450309&text= Total Harga Pesanan Saya Sebagai Berikut: " + totalAmount + " Ribu." + " Detail Pesanan yaitu: " + userShippingAddress.Makan + "." + " Apakah Pesanan tersedia dan ada tambahan biaya?. " + " Apabila Ada, Tolong Chat Biaya Tambahan dan Antarkan Pesanan Pada Kamar Berikut ya: " + userShippingAddress.phone + "." + " Atas Nama: " +  userShippingAddress.name + ". Pembayaran Di Tempat ya.");
    window.open("https://api.whatsapp.com/send/?phone=6281399455956&text= Total Harga Pesanan Saya Sebagai Berikut: " + totalAmount + " Ribu." + " Detail Pesanan yaitu: " + userShippingAddress.Makan + "." + " Apakah Pesanan tersedia dan ada tambahan biaya?. " + " Apabila Ada, Tolong Chat Biaya Tambahan dan Antarkan Pesanan Pada Kamar Berikut ya: " + userShippingAddress.phone + "." + " Atas Nama: " +  userShippingAddress.name + ". Pembayaran Di Tempat ya.");
  };
  const submitHandler2 = (e) => {
    e.preventDefault();
    const userShippingAddress = {
      name: enterName,
      phone: enterNumber,
      Makan: enterMakan,
    };
    shippingInfo.push(userShippingAddress);
    console.log(shippingInfo);
    window.open("https://api.whatsapp.com/send/?phone=628122389494&text= Total Harga Pesanan Saya Sebagai Berikut: " + totalAmount + " Ribu." + " Detail Pesanan yaitu: " + userShippingAddress.Makan + "." + " Apakah Pesanan tersedia dan ada tambahan biaya?. " + " Apabila Ada, Tolong Chat Biaya Tambahan dan Antarkan Pesanan Pada Kamar Berikut ya: " + userShippingAddress.phone + "." + " Atas Nama: " +  userShippingAddress.name + ". Pembayaran Di Tempat ya.");
  };
  const submitClose = (e) => {
    window.location.reload();
  };
  //window.location.reload();

  return (
    <Helmet title="Checkout">
      <CommonSection title="Checkout" />
      <section>
        <Container>
          <Row>
          <Col lg="4" md="6">
              <div className="checkout__bill">
              <h6 className="mb-4">Pembayaran Langsung Di Tempat Saat Makanan Sudah Diantar Ya!</h6>
              <h6 className="mb-4">Jangan Lupa, Copy Nama Makanan Ke Form Pemesanan ya:)</h6>
              <h6 className="mb-4">Hapus Data Makanan dan Refresh Formnya ya! setelah chat WA, Terimakasih:)</h6>
              <h6 className="mb-4">Maksimal 2 Menu Setiap Checkout. Agar Cepat Diantar:)</h6>
                <h6 className="d-flex align-items-center justify-content-between mb-3">
                  Pesanan: 
                    {cartItems.map((item) => (
                      <Tr item={item} key={item.id} />
                    ))}
                </h6>
                <h6 className="d-flex align-items-center justify-content-between mb-3">
                  Subtotal: <span>Rp.{cartTotalAmount} Ribu</span>
                </h6>
                <h6 className="d-flex align-items-center justify-content-between mb-3">
                  Biaya Kirim: <span>Rp.{shippingCost} Ribu</span>
                </h6>
                <div className="checkout__total">
                  <h5 className="d-flex align-items-center justify-content-between">
                    Total: <span>Rp.{totalAmount} Ribu</span>
                  </h5>
                </div>
              </div>
              <br></br>
              <br></br>
            </Col>
            <Col lg="8" md="6">
              <h6 className="mb-4">Isi Form Pemesanannya Dulu Ya!</h6>
              <form className="checkout__form" onSubmit={submitHandler}>
                <div className="form__group">
                  <input className="validate"
                    id="wa_name"
                    name="nama"
                    type="text"
                    placeholder="Nama Kamu"
                    required
                    onChange={(e) => setEnterName(e.target.value)}
                  />
                </div>
                <div className="form__group">
                  <input className="validate"
                    type="number"
                    placeholder="Nomor Kamar"
                    required
                    onChange={(e) => setEnterNumber(e.target.value)}
                  />
                </div>
                <div className="form__group">
                  <input className="validate"
                    name="makan"
                    type="text"
                    placeholder="Detail Pesanan, Contoh: (Nasi Goreng + Telur)"
                    required
                    onChange={(e) => setEnterMakan(e.target.value)}
                  />
                </div>
                <div>
                  <button type="submit" className="addTOCart__btn2">
                    Whatsapp 1
                  </button>
                  &ensp;
                  &ensp;
                  <button type="submit" className="addTOCart__btn2" onClick={submitHandler2}>
                    Whatsapp 2
                  </button>
                </div>
                <br></br>
                <button type="submit" className="addTOCart__btn" onClick={submitClose}>
                  Refresh Form
                </button>
              </form>
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

const Tr = (props) => {
  const {id, title} = props.item;
  const dispatch = useDispatch();
  const deleteItem = () => {
    dispatch(cartActions.deleteItem(id));
  };
  return (
     <td>
      <span>
        <h7><font color="blue">{title}</font></h7>

      </span>
      <div>
        <br></br>
        <button class="ri-delete-bin-line" className="addTOCart__btn" onClick={deleteItem}>Hapus Pesanan</button>
      </div>
     </td>
  );
};

export default Checkout;
